export default __webpack_public_path__ + "static/media/empty-token.b8b3d81c.webp";